import { useAtom } from 'jotai';
import { Stack } from '@mui/material';
import { ReportComments } from '../../shared/ReportComments';
import { Snackbar } from '@/components/shared/Snackbar';
import * as state from '@/components/Analysis/state';
import { EquipmentsList } from './EquipmentsList';
import { ReportInternalType } from '@/__generated__/graphql';
import { ComponentReportNavigator } from './ComponentReportNavigator';

export const ComponentReportContainer = () => {
  const [snackbarMessage, setSnackbarMessage] = useAtom(state.snackbarMessage);

  const { shouldShow, content, persistent, duration } = snackbarMessage;
  const closeSnack = (_?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarMessage({ shouldShow: false, content: undefined });
  };

  return (
    <>
      <Stack direction="row">
        <ComponentReportNavigator />
        <EquipmentsList reportType={ReportInternalType.Component} />
      </Stack>

      <ReportComments />
      <Snackbar 
        open={shouldShow} 
        onClose={closeSnack}
        persistent={persistent}
        autoHideDuration={duration}
      >
        {content}
      </Snackbar>
    </>
  );
};
